import { editAccountCreationConfig, getAccountCreationConfig } from "@/service/appList";
export default {
  name: "AppDetailTab7",
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      form: {
        permitsCreateOrUpdate: "F",
        permitsHalt: "F"
      }
    };
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    /*
     * 查询配置
     */
    async getConfig() {
      let res = await getAccountCreationConfig("OPERA_CLOUD");
      if (res.data && res.data.result === 0) {
        this.form.permitsCreateOrUpdate = res.data.retVal.permitsCreateOrUpdate || "F";
        this.form.permitsHalt = res.data.retVal.permitsHalt || "F";
      }
    },
    /*
     * 允许创建或关联账号
     */
    async changeConfigPer() {
      const params = {
        permitsCreateOrUpdate: this.form.permitsCreateOrUpdate
      };
      let res = await editAccountCreationConfig("OPERA_CLOUD", params);
      if (res.data && res.data.result === 0) {
        this.$Message.success($t("d1spvi4", "操作成功"));
      } else {
        this.getConfig();
      }
    },
    /*
     * 允许停用账号
     */
    async changeConfig() {
      const params = {
        permitsHalt: this.form.permitsHalt
      };
      let res = await editAccountCreationConfig("OPERA_CLOUD", params);
      if (res.data && res.data.result === 0) {
        this.$Message.success($t("d1spvi4", "操作成功"));
      } else {
        this.getConfig();
      }
    }
  }
};